module.exports = __webpack_public_path__ + "img/plus-icon-white.70385616.svg";